import * as React from "react";
import { createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#A2B99F",
            contrastText: "#ffffff",
        },
        secondary: {
            main: "#2B3F3D",
            contrastText: "#ffffff",
        },
        success: {
            main: "#5D8773",
        },
    },
    typography: {
        h1: {
            fontSize: "2rem",
        },
        h2: {
            fontSize: "1.8rem",
        },
        h3: {
            fontSize: "1.6rem",
        },
        h4: {
            fontSize: "1.3rem",
            marginBottom: "0.6rem",
        },
        body1: {
            fontSize: "0.9rem",
        },
    },
});

export function ThemeProvider(props) {
    return <MuiThemeProvider theme={theme}>{props.children}</MuiThemeProvider>;
}
